import React from 'react';
import { Brush, CartesianGrid, Label, Legend, Line, LineChart, XAxis, YAxis, ComposedChart, ResponsiveContainer } from 'recharts';
import i18next from 'i18next';

import GraphUtility from './graph_utility';

class ComparisonGraph extends React.Component {
  constructor(props) {
    super(props);

    this.MAIN_GRAPH_WIDTH = 900;
    this.LEGEND_WIDTH = 100;
    this.BRUSH_GRAPH_WIDTH = this.MAIN_GRAPH_WIDTH - this.LEGEND_WIDTH;
    this.BRUSH_GRAPH_HEIGHT = 150;
    this.GRAPH_X_HEIGHT = 50;
    this.BRUSH_HEIGHT = this.BRUSH_GRAPH_HEIGHT - this.GRAPH_X_HEIGHT;

    // Set up combined list of data
    let deviceNames = [...new Set(this.props.data.map(item => item.deviceName))];
    let allData = [];
    for (let i = 0; i < deviceNames.length; i++) {
      allData = allData.concat(
        this.props.data.filter(
          obs => obs.deviceName === deviceNames[i]).map(
            (obs) => ({...obs, ["amount" + (i+1).toString()]: obs.amount, timestamp: obs.timestamp}
          )
        )
      );
    }

    this.state = {
      startIndex: 0,
      endIndex: this.props.data.length - 1,
      deviceNames: deviceNames,
      sortedData: allData.sort((a, b) => {return a.timestamp - b.timestamp})
    }

    // Bind class methods
    this.calculateTicks = this.calculateTicks.bind(this);
    this.formatTicks = this.formatTicks.bind(this);
    this.renderLines = this.renderLines.bind(this);

  }

  calculateTicks(args) {
    const data = this.state.sortedData;
    const brushStart = data[!args.brush ? this.state.startIndex : 0].timestamp;
    const brushEnd = data[!args.brush ? this.state.endIndex : data.length - 1].timestamp;
    return GraphUtility.calculateTicks(brushStart, brushEnd);
  }

  formatTicks(tick, isBrush = false) {
    const data = this.state.sortedData;
    const brushStart = data[isBrush ? 0 : this.state.startIndex].timestamp;
    const brushEnd = data[isBrush ? data.length - 1 : this.state.endIndex].timestamp;
    return GraphUtility.formatTicks(tick, brushStart, brushEnd);
  } 

  renderLines() {
    const colors = ["#ffa500", "#1b82b7", "#e74c3c", "#1abc9c", "#9b59b6"];
    return this.state.deviceNames.map((device, index) => (
        <Line key={index+1} connectNulls type="step" dot={false} dataKey={"amount" + (index+1)} name={device} stroke={colors[index]} strokeWidth={2} isAnimationActive={false}/>
      )
    );
  }

  renderBrush() {
    const { yAxisLabel } = this.props;
    const firstTime = this.state.sortedData[0].timestamp;
    const lastTime = this.state.sortedData[this.state.sortedData.length - 1].timestamp;

    return (
      <div className="chart-brush-container">
        <div>
          <LineChart width={this.BRUSH_GRAPH_WIDTH} height={this.BRUSH_GRAPH_HEIGHT} data={this.state.sortedData}>
            <CartesianGrid strokeDasharray="0 0"/>
            <XAxis type="number" dataKey="timestamp" scale="time" ticks={this.calculateTicks({brush: true})} domain={[firstTime, lastTime]} tickFormatter={(tick) => this.formatTicks(tick, true)} height={this.GRAPH_X_HEIGHT} >
              <Label value={i18next.t('graphing.date-time')} offset={10} position="insideBottom"/>
            </XAxis>
            <YAxis type="number" allowDecimals={false} domain={['auto', 'auto']} padding={{top: 15, bottom: 15}} width={80}/>
            {this.renderLines()}
          </LineChart>
        </div>
        <div className="chart-brush">
          <ComposedChart width={this.BRUSH_GRAPH_WIDTH} height={this.BRUSH_HEIGHT} data={this.state.sortedData}>
            <XAxis type="number" dataKey="timestamp" scale="time" domain={[firstTime, lastTime]} height={-60}/>
            <YAxis type="number" domain={['auto', 'auto']} width={80}></YAxis>
            <Brush height={this.BRUSH_HEIGHT} dataKey='timestamp' startIndex={this.state.startIndex} endIndex={this.state.endIndex} fill="rgba(0, 0, 0, 0)" stroke="gray" onChange={(args) => this.setState({startIndex: args.startIndex, endIndex: args.endIndex})} tickFormatter={() => ""}/>
          </ComposedChart>
        </div>
      </div>
    );
  }

  render() {
    const { yAxisLabel } = this.props;
    const data = this.state.sortedData.slice(this.state.startIndex, this.state.endIndex - 1);
    const firstTime = this.state.sortedData[this.state.startIndex].timestamp;
    const lastTime = this.state.sortedData[this.state.endIndex].timestamp;

    return (
        <div>
          <LineChart width={this.MAIN_GRAPH_WIDTH} height={400} data={data}>
            <CartesianGrid strokeDasharray="0 0"/>
            <Legend width={this.LEGEND_WIDTH} layout="vertical" align="right" verticalAlign="top" wrapperStyle={{fontSize: 10, right: "-5px"}} icon="plainline"/>

            <XAxis type="number" dataKey="timestamp" scale="time" ticks={this.calculateTicks({brush: false})} domain={[firstTime, lastTime]} tickFormatter={this.formatTicks} height={this.GRAPH_X_HEIGHT}>
              <Label value={i18next.t('graphing.date-time')} offset={10} position="insideBottom"/>
            </XAxis>
            <YAxis type="number" allowDecimals={true} domain={['auto', 'auto']} label={{ value: yAxisLabel, angle: -90, position: 'insideLeft' }} width={80}></YAxis>

            {this.renderLines()}

          </LineChart>

        {this.renderBrush()}
      </div>
    );
  }
}

export default ComparisonGraph;
